import React, { useCallback, useState } from "react";
import { node, element, bool, string } from "prop-types";
import HeaderTag from "./Tag";
import HeaderContainer from "./Container";
import HeaderToggle from "./Toggle";
import HeaderCollapse from "./Collapse";
import context from "./context";

const Header = ({
	hero = false,
	isBorderBottomNone = false,
	className = "",
	logo,
	children,
	withToggle,
}) => {
	const [isOpen, setOpen] = useState(false);
	const onOpen = useCallback(() => {
		setOpen(true);
	}, [setOpen]);

	const onClose = useCallback(() => {
		setOpen(false);
	}, [setOpen]);

	const onToggle = useCallback(() => {
		setOpen(state => !state);
	}, [setOpen]);

	return (
		<context.Provider value={{ isOpen, onToggle, onOpen, onClose }}>
			<HeaderTag isHero={hero} isBorderBottomNone={isBorderBottomNone} className={className}>
				<HeaderContainer>
					<HeaderToggle withToggle={withToggle}>{logo}</HeaderToggle>
					<HeaderCollapse>{children}</HeaderCollapse>
				</HeaderContainer>
			</HeaderTag>
		</context.Provider>
	);
};

Header.propTypes = {
	hero: bool,
	isBorderBottomNone: bool,
	// inverted: bool,
	logo: element.isRequired,
	children: node,
	className: string,
	withToggle: bool,
};

export default Header;
